<template>
	<div class="docs-box">
		<div class="docs-home">

			<img src="./../../../assets/img/docs/001/04.jpeg" />
		</div>		
	</div>
</template>
<script>
	export default{
		name:'docs-invoice'
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/docs/invoice.vue